import React, { useRef, useEffect, useState } from 'react'
import { Col, Container } from 'react-bootstrap'
import { get } from 'lodash'
import { useHistory } from 'react-router-dom'

import Typography from 'components/atoms/Typography'
import ResponseBlock from 'components/molecules/ResponseBlock'
import Pagination from 'components/molecules/Pagination'
import SearchFilters from 'components/organisms/SearchFilters'
import { userCheckMobileScreen } from 'helpers/tools'
import { millisToHuman } from 'helpers/dates'
import './NewsWidget.scss'

function NewsWidget({ data, user }) {
  const history = useHistory()
  const newsRef = useRef()
  const query = new URLSearchParams(history.location.search)
  const categories = get(data, 'category')
  const queryCategory = query.getAll('type[]')
  const category = queryCategory.length > 0 ? queryCategory : []

  const [currentPage, setCurrentPage] = useState(parseInt(query.get('page')) - 1 || 0)
  const [sortOrder, setSortOrder] = useState(query.get('sort_order') || 'DESC')
  const sortOptions = [
    { name: 'Mais recentes', value: 'created', sortOrder: 'DESC' },
    { name: 'Mais antigos', value: 'created', sortOrder: 'ASC' },
  ]

  const newsItems = get(data, 'news.items')
  const pager = get(data, 'news.pager')

  useEffect(() => {
    if (query.toString()) newsRef.current.scrollIntoView()
  }, [])

  function handleChangeOrder(option) {
    setSortOrder(get(option, 'sortOrder'))
  }

  return (
    <Container ref={newsRef} className="NewsWidget news section-spacing">
      <Col>
        <Typography color="primary" cssClass="title-semibold-md mb-3" variant="h2">
          Notícias
        </Typography>
        {categories && (
          <SearchFilters
            className="news__filters"
            filters={[
              {
                text: 'Categorias',
                selectAllText: 'Todas as categorias',
                field: 'type',
                items: categories.map(({ entity: { tid, name } }) => ({
                  value: tid,
                  name,
                  selected: category.includes(tid.toString()),
                })),
              },
            ]}
            selectAllText="Todas as categorias"
            sort={{
              options: sortOptions,
              selected: sortOptions.find((option) => option.sortOrder === sortOrder),
              handleChange: handleChangeOrder,
            }}
            onSubmit={() => setCurrentPage(0)}
          />
        )}
        {newsItems?.map(({ created, title, media, url, body }, index) => {
          const image = userCheckMobileScreen()
            ? get(media, 'entity.images.wide.url')
            : get(media, 'entity.images.large.url')

          return (
            <ResponseBlock
              key={url + index}
              title={title}
              preview={get(body, 'summary')}
              link={get(url, 'path')}
              thumbnail={{
                src: image || '/sites/default/files/public/svg_icons/newspaper.svg',
                alt: get(media, 'entity.images.alt'),
              }}
              date={millisToHuman(created, { month: 'long', day: 'numeric', year: 'numeric' })}
            />
          )
        })}
        {(!newsItems || newsItems?.length === 0) && (
          <div className="d-flex justify-content-center mt-4">
            <Typography>Nenhum resultado encontrado</Typography>
          </div>
        )}
        <Pagination
          initialPage={currentPage}
          paginationOffset={2}
          totalPages={parseInt(pager?.total_pages)}
          onChangePage={(page) => setCurrentPage(page - 1)}
          useQueryParams
        />
      </Col>
    </Container>
  )
}

export default NewsWidget
